import request from "@/utils/request.js"
// 获取banner 图
export function get_banner(data) {
	return request({
		method: 'GET',
		url: '/aohua.home/get_banner_list',
		params: data
	})
}

// 首页数据
export function getHomeInfo(data) {
	return request({
		method: 'GET',
		url: '/aohua.home/get_home_info',
		params: data
	})
}

// 获取首页产品
export function get_home_product(data) {
	return request({
		method: 'GET',
		url: '/home/get_home_product',
		params: data
	})
}
// 获取首页新闻
export function get_news(data) {
	return request({
		method: 'GET',
		url: '/home/get_news',
		params: data
	})
}

// 获取首页核心技术
export function get_core_tec(data) {
	return request({
		method: 'GET',
		url: '/home/get_core_tec',
		params: data
	})
}
